module.exports = __webpack_public_path__ + "img/btnCard-6.55907b9c.jpg";